<template>
    <div class="subtitle">
        <div v-for="(item, index) in this.$props.items" class="subtitle-item">
            <span v-bind:style="{ 'background-color': item.color }"></span> {{item.text}}
            <span v-if="item.tooltip" v-b-tooltip.hover v-bind:title="item.textTooltip" class="icon-tooltip">
                <i class="icofont-info-circle"></i>
            </span>   
        </div>
    </div>
</template>

<script>
export default {
    name: "Subtitle",
    props:{
        items:{
            type: Array,
            default: () => {}
        }
    },
    data(){
        return{

        }
    }
}
</script>

<style>
 .subtitle{
     display: flex;
    align-items: center;
    justify-content: flex-end;
 }
 .subtitle-item{
    font-size: 16px;
    margin: 25px 10px;
 }
 .subtitle-item span{
    width: 15px;
    height: 15px;
    display: inline-block;
    vertical-align: middle;
 }

 .subtitle-item span i {
    font-size: 14px;
    vertical-align: top;
}

 /* 
  ##Device = Most of the Smartphones Mobiles (Portrait)
  ##Screen = B/w 320px to 479px
*/

@media (min-width: 320px) and (max-width: 480px) {
    .subtitle{
        justify-content: center;
    }
    .subtitle-item {
        font-size: 13px;
        margin: 10px 10px;
    }
}

/* 
  ##Device = Tablets, Ipads (portrait)
  ##Screen = B/w 768px to 1024px
*/

@media (min-width: 768px) and (max-width: 1024px) {
    .subtitle{
        justify-content: flex-start;
    }
    .subtitle-item {
        font-size: 13px;
        margin: 10px 10px;
    }
}
</style>
